import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { get } from "lodash";
import { string, object } from "prop-types";

import styles from "./styles.m.css";

const MGID_CONFIG = {
  mobile_below_story_ad: {
    id: "M656299ScriptRootC1204777",
    script: "https://jsc.mgid.com/v/i/vikatan.com.1204777.js"
  },
  desktop_below_story_ad: {
    id: "M656299ScriptRootC1204776",
    script: "https://jsc.mgid.com/v/i/vikatan.com.1204776.js"
  }
};

const MgidAd = ({ type, story = {} }) => {
  const [delayComponentRender, setDelayComponentRender] = useState(false);
  const [userType, setUserType] = useState("F");

  let CONFIG = MGID_CONFIG;

  const adClass = type.startsWith("desktop") ? "mgid-ad-container desktop-only" : "mgid-ad-container mobile-only";

  const mgidScript = src => {
    const s = document.createElement("script");
    s.type = "text/javascript";
    s.src = src;

    document.getElementsByTagName("head")[0].appendChild(s);
  };

  useEffect(() => {
    let timeout = null;
    timeout = setTimeout(() => {
      mgidScript(get(CONFIG, [type, "script"], null));
      setDelayComponentRender(() => {
        return true;
      });
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      setUserType(user.userType);
    });
  }, []);

  return (
    <div styleName={adClass}>
      {delayComponentRender ? (
        userType === "P" || userType === "T" || userType === "R" ? null : (
          <div>
            <span className={styles["ad-text"]}>ADVERTISEMENT</span>
            <div id={get(CONFIG, [type, "id"], null)} />
          </div>
        )
      ) : null}
    </div>
  );
};

const mapStateToProps = state => ({
  disableAds: get(state, ["qt", "config", "disableAds"])
});

MgidAd.propTypes = {
  type: string,
  story: object,
  publisher: string
};

export default connect(
  mapStateToProps,
  null
)(MgidAd);
